import { Image, Box, VStack, useColorModeValue } from "@chakra-ui/react";

import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";

import prajwalRecommandation from "../projectimages/prajwal.png";
import saurabhRecommandation from "../projectimages/saurabhsir.PNG";
import anshikaRecommandation from "../projectimages/anshika.PNG";
import sunitaRecommandation from "../projectimages/sunita.png";
import bhartiRecommandation from "../projectimages/bharti.png";
import shubhamRecommandation from "../projectimages/shubham.png";

const testimonials = [
  { image: sunitaRecommandation },
  { image: bhartiRecommandation },
  { image: anshikaRecommandation },
  { image: prajwalRecommandation },
  { image: saurabhRecommandation },
  { image: shubhamRecommandation },
];

//console.log(data)

const responsive = {
  0: { items: 1 },
  568: { items: 1 },
  1000: { items: 2 },
};

const Recommandation = () => {
  const QueryColor = useColorModeValue("#e53e3e", "#eac288");

  const data = testimonials.map((el) => (
    <VStack
      borderColor={QueryColor}
      boxShadow={"lg"}
      minH={"100%"}
      w="99%"
      bg="white"
      p={2}
      borderLeft={"4px solid" + QueryColor}
      borderRadius={10}
    >
      <Image fit={"contain"} userSelect={"-moz-none"} w="100%" src={el.image} />
    </VStack>
  ));

  return (
    <Box zIndex={2} w="full" maxW={"1400px"}>
      <AliceCarousel
        mouseTracking
        items={data}
        responsive={responsive}
        autoPlay
        infinite
        autoPlayInterval={2000}
        animationDuration={2000}
      />
    </Box>
  );
};

export default Recommandation;
